// 请求拦截

import axios from 'axios'
import {router} from '../router'
// import store from '../store'


const interceptors = instance => {
  // request 拦截器
  instance.interceptors.request.use(
    // 设置Token

    config => {
      const configTemp = config
      const url = configTemp.url.split('?')[0]
      if(url==='https://oce.fx994.com:5300/WikiSearch/wikibit/detail'||url==='https://oce.fx994.com:5300/Third/ip138/getcity'){

          configTemp.headers['Authorization'] = 'Bearer '+ window.localStorage.getItem('TOKEN') || '' 
      }
      
      // if(window.localStorage.getItem('TOKEN')){
      //   configTemp.headers['Authorization'] = 'Bearer '+ window.localStorage.getItem('TOKEN') || '' 
      // }
      // configTemp.headers.lang = window.localStorage.getItem('lang') || 'zh_CN'
      // 语言:zh_CN:中文简体、en:英文、ja_jp:日文、zh_HK:中文繁体
      return configTemp
    },
    error => Promise.reject(error)
  )
  // 登录超时错误码
  const codeArray = [401, 402, '020201']
  // response 拦截器
  instance.interceptors.response.use(
    response => {
      // if (process.env.NODE_ENV === 'development') console.info(`接口${response.config.url}响应信息:`, response)
      // 如果是二进制对象流
      if (response.headers['content-disposition']) {
        
        let filename =
        decodeURI(
            response.headers['content-disposition'].split('=')[1]
          ) || ''
        let blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8
        })

        let downloadElement = document.createElement('a'),
         href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = `${filename}`; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        window.URL.revokeObjectURL(href); // 释放掉blob对象
        return Promise.resolve({
          blob,
          filename,
        })
      }
      if(response.data.resp){

        const { respCode ,code,message} = response.data.resp
        console.log(code);
        if (code === 0) {
          return Promise.reject(
            Object.assign({}, {
              message: message,
              code: respCode
            })
          )
        }
         else if(code ==='98') {
          router.app.$router.replace({
            path: '/',
            query: {
              redirect: message
            }
          })
        }else if(code ==='15') {
          router.app.$router.replace({
            path: '/',
            query: {
              redirect: message
            }
          })
        }else if(code ==='14') {
          router.app.$router.replace({
            path: '/',
            query: {
              redirect: message
            }
          })
        }else if (!respCode) {
          return Promise.resolve(response.data)
        } else if (codeArray.includes(code)) {
          // 登录超时处理
          router.app.$router.replace({
            path: '/',
            // query: {
            //   redirect: `${router.app.$route.fullPath}`
            // }
          })
          return Promise.reject(
            Object.assign({}, {
              message: response.data.respMsg,
              code: respCode
            })
          )
        } else if (respCode === '200') {
          return Promise.resolve(response.data || '')
        } else {
          return Promise.reject(
            Object.assign({}, {
              message: response.data.message,
              code: respCode
            })
          )
        }
      }else{
        return Promise.resolve(response.data || '')
      }
    },
    error => {
      try {
        if (process.env.NODE_ENV === 'development') {
          console.error(
            `接口${error.response.config.url}响应错误信息:`,
            error.response
          )
        }
        const code = error.response.status
        let msg = error.response.data.msg
        if (code === 401) {
          console.log(code);
          router.app.$router.replace({
            path: '/',
            query:{redirect:'Token已过期,请重新登录'}
          })
        } else if (code === 404 || code === 400) {
          msg = '接口资源不存在'
        }
        // return Promise.reject(
        //   Object.assign({}, {
        //     code,
        //     message: msg || '( >﹏<。)~ 系统有点累，请稍后再试。'
        //   })
        // )
      } catch (e) {
        if (process.env.NODE_ENV === 'development') console.error(`接口异常:`, e)
        return Promise.reject(
          Object.assign({}, {
            message: '( >﹏<。)~ 接口异常',
            code: 0
          })
        )
      }
    }
  )
}

// formdata
export function URLENCODED () {
  const instance = axios.create({
    timeout: 10000, // 设置超时时间
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    transformRequest: [
      obj => {
        // const temp = Object.assign(obj || {}, { lang: '' });
        // const ret = Object.keys(temp).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(temp[k])}`).join('&');
        const ret = Object.keys(obj)
          .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
          .join('&')
        return ret
      }
    ]
  })
  interceptors(instance)
  return instance
}

// json
export function JSON () {
  const instance = axios.create({
    timeout: 15000, // 设置超时时间
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
  interceptors(instance)
  return instance
}

// upload
export function UPLOAD () {
  const instance = axios.create({
    timeout: 10000, // 设置超时时间
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  interceptors(instance)
  return instance
}

// download
export function DOWNLOAD () {
  const instance = axios.create({
    timeout: 30000, // 设置超时时间
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    responseType: 'blob'
  })
  interceptors(instance)
  return instance
}
